<section class="container">
  <div class="row my-4">
    <div class="col-12">
      <div class="topNavbar mb-1">
        <button mat-button class="m-1" style="color:var(--warmOrange);" (click)="backTo();">
          <mat-icon>arrow_back_ios_new</mat-icon> {{'goBack' | translate}}
        </button>
        <span class="fs-5">{{'finished.table_title' | translate}}: {{titleTask}}</span>
        <div></div>
      </div>

      @if (tridyId) {
        <div>
          <div class="mt-4 mb-2 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">qr_code</mat-icon>{{'tridys.tridy' | translate}}
          </div>
          <mat-card class="mb-2 shadow-sm">
            <mat-card-content class="my-2">
              <div >
                <div class="item-content my-1" (click)="redirectTo(finishedTask);">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      <span style="color:var(--warmOrange);">{{'tridys.tridy' | translate}}: </span><span>{{tridyId}}</span>
                    </div>
                    <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }

      @if (sections && sections.length > 0) {
        <div>
          <div class="mt-4 mb-2 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">checklist</mat-icon> {{'workTask.finishedTaskResults' | translate}}
          </div>
          @for (section of sections; track section) {
            <mat-accordion class="w-100 mb-2">
              <mat-expansion-panel expanded class="mb-1">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{section.title}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @for (field of section.fields; track field) {
                  <mat-card class="mb-1 shadow-sm" >
                    <mat-card-content class="py-2 px-3">
                      <div class="d-flex flex-row justify-content-between">
                        <div class="field-title">
                          @if (field.type=='barcode') {
                            <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                          }
                          @if (field.type=='signature') {
                            <mat-icon class="material-symbols-outlined">signature</mat-icon>
                          }
                          @if (field.type=='boolean') {
                            <mat-icon class="material-symbols-outlined">toggle_on</mat-icon>
                          }
                          @if (field.type=='currency') {
                            <mat-icon class="material-symbols-outlined">euro</mat-icon>
                          }
                          @if (field.type=='dateTime') {
                            <mat-icon class="material-symbols-outlined">calendar_month</mat-icon>
                          }
                          @if (field.type=='decimal') {
                            <mat-icon class="material-symbols-outlined">numbers</mat-icon>
                          }
                          @if (field.type=='display') {
                            <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                          }
                          @if (field.type=='document') {
                            <mat-icon class="material-symbols-outlined">attach_file</mat-icon>
                          }
                          @if (field.type=='hidden') {
                            <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>
                          }
                          @if (field.type=='longText') {
                            <mat-icon class="material-symbols-outlined">subject</mat-icon>
                          }
                          @if (field.type=='number') {
                            <mat-icon class="material-symbols-outlined">pin</mat-icon>
                          }
                          @if (field.type=='text') {
                            <mat-icon class="material-symbols-outlined">text_format</mat-icon>
                          }
                          @if (field.type=='tridy') {
                            <mat-icon class="material-symbols-outlined">contactless</mat-icon>
                          }
                          @if (field.type=='options') {
                            <mat-icon class="material-symbols-outlined">list</mat-icon>
                          }
                          @if (field.type=='weight') {
                            <mat-icon class="material-symbols-outlined">weight</mat-icon>
                          }
                          @if (field.type=='nfc') {
                            <mat-icon class="material-symbols-outlined">nfc</mat-icon>
                          }
                          @if (field.type=='showImage') {
                            <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
                          }
                          @if (field.type=='showText') {
                            <mat-icon class="material-symbols-outlined">image</mat-icon>
                          }
                          <span class="font-weight-bold">{{field.title}}</span>
                        </div>
                        <div>
                          @if (field.payloadKey && !field.key) {
                            <div class="text-end">
                              @if (field.type!='document' && field.type!='dateTime' && field.type!='weight' && field.type!='boolean') {
                                <span class="text-muted text-end"> {{finishedTask.payload[field.payloadKey]}}</span>
                              }
                              @if (field.type=='boolean') {
                                <div class="ps-1 d-flex">
                                  <span class="text-muted">{{finishedTask.payload[field.payloadKey]}}</span>
                                  <span>{{finishedTask.payload[field.payloadKey]}}</span>
                                </div>
                              }
                              @if ( finishedTask.payload[field.payloadKey] && field.type=='weight') {
                                <div  class="ps-1 d-flex">
                                  <span class="text-muted" >{{finishedTask.payload[field.payloadKey]}}</span>
                                </div>
                              }
                              @if ( finishedTask.payload[field.payloadKey] && field.type=='dateTime') {
                                <div class="d-flex">
                                  @if (field.payloadKey) {
                                    <div class="text-muted">
                                      {{convertDateTime(finishedTask.payload[field.payloadKey], field.style)}}
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if ( finishedTask.payload && field.key) {
                            <div class="d-flex">
                              @if ( field.type!='document' && field.type!='dateTime' && field.type!='weight' && field.type!='boolean' && field.type!='signature') {
                                <span class="text-muted text-break text-wrap text-end"> {{finishedTask.payload[field.key]}}</span>
                              }
                              @if ( field.type=='boolean') {
                                <div class="ps-1 d-flex text-end">
                                  <span class="text-muted">{{finishedTask.payload[field.key]}}</span>
                                </div>
                              }
                              @if ( field.type=='weight') {
                                <div  class="ps-1 d-flex">
                                  @if (finishedTask.payload[field.key] && finishedTask.payload[field.key]['value']) {
                                    <span class="text-muted">{{finishedTask.payload[field.key]['value']}}</span>
                                  }
                                </div>
                              }
                              @if ( field.type=='dateTime') {
                                <div class="d-flex">
                                  @if (field.key) {
                                    <div class="text-muted">
                                      {{convertDateTime(finishedTask.payload[field.key], field.style)}}
                                    </div>
                                  }
                                </div>
                              }
                              @if ( field.type=='document' || field.type =='signature') {
                                <div  class="ps-1 d-flex align-items-center">
                                  <!-- <a href="{{docs[field.key]}}" target="_blank"> -->
                                  <!-- <img [src]="docs[field.key]" style="height:150px;width:auto;"> -->
                                <!-- </a> -->
                                @if (docs[field.key]) {
                                  <div>
                                    @if (!fileIsPDF(field.key)) {
                                      <a href="{{docs[field.key]}}" target="_blank" style="cursor:zoom-in;">
                                        <img [src]="docs[field.key]" style="height:150px;width:auto;" ><!--onerror="this.src='./../../assets/img/default.jpg'" class="image-hover rounded" style="object-fit: cover;"-->
                                      </a>
                                    }
                                    @if (fileIsPDF(field.key)) {
                                      <a href="{{docs[field.key]}}" class="pdf-title" target="_blank">
                                        <div><mat-icon class="material-symbols-outlined">open_in_new</mat-icon>PDF</div>
                                      </a>
                                    }
                                  </div>
                                }
                                @if (!docs[field.key]) {
                                  <span class="material-symbols-outlined text-muted">
                                    attach_file
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        }
                        @if ( !finishedTask.payload) {
                          <div class="d-flex">
                            @if ( field.type=='showText') {
                              <div class="ps-1 d-flex text-end">
                                <span class="text-muted">{{field.value}}</span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    }


    @if (finishedTask && finishedTask.incomingTridys && finishedTask.incomingTridys.length!=0) {
      <div class="mb-2">
        <div class="mt-4 mb-2 section-title">
          <mat-icon class="custom-card-icon material-symbols-outlined">input</mat-icon>{{'workTask.incoming_tridys' | translate}}
        </div>
        <mat-card class="mb-2">
          <mat-card-content class="my-2">
            @if (finishedTask.incomingTridys) {
              <div>
                @for (incoming of finishedTask.incomingTridys; track incoming) {
                  <div class="item-content my-1" (click)="redirectTo(incoming)">
                    <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                      <div class="d-flex flex-column flex-nowrap">
                        <span style="color:var(--warmOrange);">{{getContentTypeIdData(incoming.contentTypeId, 'displayName')}}</span>
                        <!-- <div>{{incoming.tridyId}}</div> -->
                        <div matTooltip="Created: {{isDateTime(getTRIDYIdData(incoming.tridyId, 'creationDate')) }}, Updated: {{isDateTime(getTRIDYIdData(incoming.tridyId, 'timeStamp')) }}">
                          <mat-icon class="time-icon">schedule</mat-icon><span class="text-muted"> {{isDateTime(getTRIDYIdData(incoming.tridyId, 'timeStamp')) }}</span>
                        </div>
                      </div>
                      <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                        keyboard_arrow_right
                      </span>
                    </div>
                  </div>
                }
              </div>
            }
            @if (finishedTask.incomingTridys.length==0) {
              <div class="p-3">
                <span class="text-muted">{{'workTask.empty' | translate}}</span>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }

    @if (finishedTask && finishedTask.outgoingTridys &&  finishedTask.outgoingTridys.length!=0) {
      <div class="mb-2">
        <div class="mt-4 mb-2 section-title">
          <mat-icon class="custom-card-icon material-symbols-outlined">output</mat-icon>{{'workTask.outgoing_tridys' | translate}}
        </div>
        <mat-card class="mb-2">
          <mat-card-content class="my-2">
            @if (finishedTask.outgoingTridys) {
              <div>
                @for (outgoing of finishedTask.outgoingTridys; track outgoing) {
                  <div class="item-content my-1" (click)="redirectTo(outgoing)">
                    <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                      <div class="d-flex flex-column flex-nowrap">
                        <span style="color:var(--warmOrange);">{{getContentTypeIdData(outgoing.contentTypeId, 'displayName')}}</span>
                        <!-- <div>{{outgoing.tridyId}}</div> -->
                        <div matTooltip="Created: {{isDateTime(getContentTypeIdData(outgoing.contentTypeId, 'creationDate')) }}, Updated: {{isDateTime(getContentTypeIdData(outgoing.contentTypeId, 'timeStamp')) }}">
                          <mat-icon class="time-icon">schedule</mat-icon><span class="text-muted"> {{isDateTime(getContentTypeIdData(outgoing.contentTypeId, 'timeStamp')) }}</span>
                        </div>
                      </div>
                      <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                        keyboard_arrow_right
                      </span>
                    </div>
                  </div>
                }
              </div>
            }
            @if (finishedTask.outgoingTridys.length==0) {
              <div class="p-3">
                <span class="text-muted">{{'workTask.empty' | translate}}</span>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }

    @if (!sections && !locationCoordinates) {
      <div class="container">
        <p>{{'finished.no_sections' | translate}}</p>
      </div>
    }

    @if (locationCoordinates) {
      <div>
        <div class="mt-4 mb-2 section-title">
          <mat-icon class="custom-card-icon material-symbols-outlined">location_on</mat-icon> {{'location' | translate}}
        </div>
        <mat-card class="mb-5">
          <mat-card-content class="m-0 p-0">
            <div class="d-flex align-items-center px-4 py-3">
              <span class="text-muted">{{'workTask.coordinates' | translate}}: {{locationCoordinates.latitude}}, {{locationCoordinates.longitude}} </span>
              <mat-icon matTooltip="{{'copyToClipboard' | translate}}" cdkCopyToClipboard="{{locationCoordinates.latitude}}, {{locationCoordinates.longitude}}" class="copy_coordinates">content_copy</mat-icon>
            </div>
            <div class="container-map shadow-sm">
              <div [app-finished-tasks-map]="locationCoordinates"></div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
</div>
</section>